import { Form } from 'react-final-form'
import { useCallback } from 'react'

import { Button } from '@elements/button'
import { ErrorNote } from '@elements/error-note'
import { TextField } from '@components/form-field/text'

import { createValidator, validations } from '@lib/validation'
import { useSession } from '@hooks/session'
import { TablelistLogo } from '@icons/tablelist-logo'

type LoginFormValues = {
  email: string
  password: string
}

const loginValidator = createValidator<LoginFormValues>({
  email: validations
    .string()
    .required('Email is required')
    .email('Please provide a valid email address'),
  password: validations.string().required('Password is required'),
})

export interface LoginFormProps {
  afterLogin?: () => void | Promise<void>
  onForgotPassword?: () => void
}

export function LoginForm({ afterLogin, onForgotPassword }: LoginFormProps) {
  const { login, authError } = useSession()

  const submit = useCallback(
    async (values: LoginFormValues) => {
      const success = await login(values.email, values.password)
      if (success) afterLogin?.()
    },
    [afterLogin, login]
  )

  return (
    <div className='w-full'>
      <Form onSubmit={submit} validate={loginValidator}>
        {({ handleSubmit, submitting }) => (
          <form
            onSubmit={handleSubmit}
            className='flex flex-col items-start justify-start w-full xs:min-w-[320px] sm:min-w-[364px] space-y-6'
          >
            <div className='w-full space-y-3'>
              <TextField
                autoComplete='username'
                name='email'
                type='email'
                label='Email'
                placeholder=''
              />
              <TextField
                autoComplete='current-password'
                name='password'
                type='password'
                label='Password'
                placeholder='******'
                className='mb-3'
              />
              <span className='link' onClick={onForgotPassword}>
                Forgot your password?
              </span>
            </div>
            <Button.Submit loading={submitting} className='w-full'>
              <div className='flex items-center space-x-2'>
                <TablelistLogo fill='white' className='w-5 h-5' />{' '}
                <span>Login</span>
              </div>
            </Button.Submit>
            <ErrorNote>{authError}</ErrorNote>
          </form>
        )}
      </Form>
    </div>
  )
}
